import React, { Component } from "react";
import { PropTypes } from "prop-types";
import {
    Button,
    Row,
    Col,
    ButtonToolbar,
    Table,
    FormControl,
    ControlLabel,
    Tab,
    Tabs,
} from "react-bootstrap";
import { LoadingSpinner } from "../../../LoadingSpinner";
import { TitleRow } from "../../../TitleRow";
import DatePicker from "react-16-bootstrap-date-picker";
import { LinesCommand } from "../../commands/LinesCommand";
import { SchedulesCommand } from "../../commands/SchedulesCommand";
import { DayTypesCommand } from "../../../datamanager/commands/DayTypesCommand";
import { HandleMessage } from "../../../HandleMessage";
import { DrawCommand } from "../../commands/DrawCommand";
import { PathStopsCommand } from "../../commands/PathStopsCommand";
import { SortIndicator } from "react-virtualized";

const TYPE_TABULAR = 'T'
const TYPE_FREQUENCY = 'F'
const TYPE_STATION = 'S'

export class ViaPortoScheduleGenerator extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            edition: undefined,
            selectedScheduleType: 'T',
            tabHasChanges: false,
            actions: {
                isLoadingLines: false,
                isLoadingStops: false,
                isLoadingSchedules: false,
                isLoadingDayTypes: false,
                isGenerating: false
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined,
            },
            commands: {
                lines: new LinesCommand(),
                stops: new PathStopsCommand(),
                scheds: new SchedulesCommand(),
                dayTypes: new DayTypesCommand(),
                draw: new DrawCommand()
            },
            data: {
                lines: [],
                stops: [],
                schedules: [],
                dayTypes: [],
            },
            sort:{
                column: "code",
                order: "ascending"
            },
            selectedLine: undefined,
            selectedStops: [],
            selectedSchedules: {
                weekdaySchedules: [],
                saturdaySchedules: [],
                sundaySchedules: []
            },
            selectedDayTypes: [],
            referenceDate: new Date().toISOString(),
            headerAndFooter: {
                Header1: "CA1",
                Header2: "CA2",
                Footer1: "RO1",
                Footer2: "RO2",
            },
        };
    }

    componentDidMount() {
        this.context.selectApp("bussched", false);
        const edition = this.context.getOwnEdition();

        this.getLines(edition);
        this.getDayTypes();
        this.setState({
            edition: edition
        });
    }

    getLines(edition) {
        const { commands, actions } = this.state;

        actions.isLoadingLines = true;

        commands.lines.list(
            edition.network,
            (a) => this.listSuccessCallback(a, 'lines', 'isLoadingLines'),
            (a) => this.listErrorCallback(a, 'lines', 'isLoadingLines')
        );

        this.setState({
            actions: actions
        })
    }

    getStops() {
        const { selectedLine, commands, actions, edition } = this.state;

        actions.isLoadingStops = true;

        commands.stops.listStops(
            edition.network,
            selectedLine.id,
            (a) => this.listSuccessCallback(a, 'stops', 'isLoadingStops'),
            (a) => this.listErrorCallback(a, 'stops', 'isLoadingStops')
        );

        this.setState({
            actions: actions
        })
    }

    getSchedules(line) {
        const { commands, edition, actions, referenceDate } = this.state;

        actions.isLoadingSchedules = true;

        const tmpDate = new Date(referenceDate);

        commands.scheds.activeByLine(
            edition.planning, line, tmpDate.getTime(),
            (a) => this.listSuccessCallback(a, 'schedules', 'isLoadingSchedules'),
            (a) => this.listErrorCallback(a, 'schedules', 'isLoadingSchedules')
        );

        this.setState({
            actions: actions
        });
    }

    getDayTypes() {
        const { commands, actions } = this.state;

        actions.isLoadingDayTypes = true;

        commands.dayTypes.getAll('',
            (a) => this.listSuccessCallback(a, 'dayTypes', 'isLoadingDayTypes'),
            (a) => this.listErrorCallback(a, 'dayTypes', 'isLoadingDayTypes')
        );

        this.setState({
            actions: actions
        });
    }

    listSuccessCallback(result, dataType, action) {
        const { data, actions } = this.state;

        data[dataType] = result;

        actions[action] = false;

        this.setState({
            data: data,
            actions: actions
        })
    }

    listErrorCallback(result, dataType, action) {
        const { data, actions, message } = this.state;

        actions[action] = false;
        data[dataType] = [];

        if (message.show) {
            result = `${message.message}\n${result}`;
        }

        this.setState({
            data: data,
            actions: actions,
            message: {
                show: true,
                message: result,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    isWeekdaySchedule(sched) {
        const dayTypes = sched.setOfDayTypes.dayTypes.map(dt => dt.name);
        return dayTypes.includes("Segunda-Feira") ||
            dayTypes.includes("Terça-Feira") ||
            dayTypes.includes("Quarta-Feira") ||
            dayTypes.includes("Quinta-Feira") ||
            dayTypes.includes("Sexta-Feira");
    }

    isSaturdaySchedule(sched) {
        const dayTypes = sched.setOfDayTypes.dayTypes.map(dt => dt.name);
        return dayTypes.includes("Sábado");
    }

    isSundaySchedule(sched) {
        const dayTypes = sched.setOfDayTypes.dayTypes.map(dt => dt.name);
        return dayTypes.includes("Domingo") || dayTypes.includes("Feriado");
    }

    getSchedTypeName(schedType) {
        switch (schedType) {
            case 'weekdaySchedules': return "Dias Úteis";
            case 'saturdaySchedules': return "Sábados";
            case 'sundaySchedules': return "Domingos";
            default: return "";
        }
    }

    selectScheduleType(selectedScheduleType) {
        if (this.state.tabHasChanges) {
            // TODO show the message
            return;
        }
        this.setState({ selectedScheduleType });
    };

    onExit() {
        var { message } = this.state;

        message = {
            show: false,
            title: undefined,
            message: undefined,
            style: undefined,
            icon: undefined,
            argument: undefined,
        }

        this.setState({
            message: message
        });
    }

    onLineRowClick(line) {
        var { selectedLine } = this.state;

        selectedLine === line ? selectedLine = undefined : selectedLine = line;

        this.setState({
            selectedLine: selectedLine,
        }, () => {
            this.updateSelectedSchedules();
            this.updateStops();
        }
        );
    };

    onScheduleRowClick(schedType, schedule) {
        var { selectedSchedules } = this.state;

        var index = selectedSchedules[schedType].findIndex(id => id === schedule.id);
        if (index !== -1) {
            selectedSchedules[schedType].splice(index, 1);
        }
        else {
            selectedSchedules[schedType].push(schedule.id);
        }

        this.setState({
            selectedSchedules: selectedSchedules
        });
    };

    handleReferenceDateChange(e) {
        let { referenceDate } = this.state;

        let date = e !== null ? e : referenceDate;
        this.setState({ referenceDate: date }, this.updateSelectedSchedules);
    }

    updateSelectedSchedules() {
        var { selectedSchedules, selectedLine } = this.state;

        selectedSchedules.weekdaySchedules = [];
        selectedSchedules.saturdaySchedules = [];
        selectedSchedules.sundaySchedules = [];

        this.setState({
            selectedSchedules: selectedSchedules
        }, () => {
            if (selectedLine !== undefined) {
                this.getSchedules(selectedLine.id);
            }
        });
    };

    updateStops() {
        const { selectedLine } = this.state;

        this.setState({
            selectedStops: []
        }, () => {
            if (selectedLine !== undefined) {
                this.getStops(selectedLine.id);
            }
        })

    }

    storeValue = (param, value) => {
        var { headerAndFooter } = this.state;

        headerAndFooter[param] = value;

        this.setState({ headerAndFooter });
    };

    renderLinesTab() {
        const { data, selectedLine, actions, sort } = this.state;

        let lines = data['lines'];

        return (
            <Tab eventKey={1} key="lines" title="Linhas">
                {actions.isLoadingLines ? <LoadingSpinner />
                    : (
                        <Col sm={12}>
                            {undefined !== lines && lines.length !== 0 ? (
                                <Table responsive striped hover>
                                    <thead>
                                        <tr>
                                            <th onClick={() => this.onChangeSort('code')}>
                                                Código {sort.column === 'code' ? <SortIndicator order={sort.order}/> : <SortIndicator order='none'/>}
                                            </th>
                                            <th onClick={() => this.onChangeSort('extCode')}>
                                                Código Externo {sort.column === 'extCode' ? <SortIndicator order={sort.order}/> : <SortIndicator order='none'/>}
                                            </th>
                                            <th onClick={() => this.onChangeSort('goName')}>
                                                Nome de Ida {sort.column === 'goName' ? <SortIndicator order={sort.order}/> : <SortIndicator order='none'/>}
                                            </th>
                                            <th onClick={() => this.onChangeSort('returnName')}>
                                                Nome de Volta {sort.column === 'returnName' ? <SortIndicator order={sort.order}/> : <SortIndicator order='none'/>}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lines
                                            .sort((a, b) => this.sort(a, b))
                                            .map((line, index) => (
                                                <tr
                                                    key={`line-${index}`}
                                                    onClick={() => this.onLineRowClick(line)}
                                                    className={`selectable  
                                                        ${selectedLine !== undefined && selectedLine.id === line.id
                                                            ? "bus-sched-line-selected"
                                                            : null
                                                        }`}
                                                >
                                                    <td>{line.code}</td>
                                                    <td>{line.extCode}</td>
                                                    <td>{line.goName}</td>
                                                    <td>{line.returnName}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="empty-set">Não existem linhas disponíveis.</p>
                            )}
                        </Col>
                    )}
            </Tab>
        );
    };

    renderSchedulesTable(schedType, schedules) {
        const { selectedSchedules } = this.state;

        return (
            <Row key={`${schedType}-schedules-tab-row`}>
                <TitleRow
                    title={this.getSchedTypeName(schedType)}
                    showSeparator={false}
                    showBackground={false}
                    element="h2"
                >
                </TitleRow>
                {undefined !== schedules && schedules.length !== 0 ? (
                    <Table responsive striped hover>
                        <tbody>
                            {schedules.map((sched) => (
                                <tr className={`selectable  
                                ${selectedSchedules[schedType].findIndex((id) => id === sched.id) !== -1 ?
                                        "bus-sched-line-selected" : null}`
                                }
                                    onClick={() => this.onScheduleRowClick(schedType, sched)}
                                >
                                    <td className="width-70p">{sched.name}</td>
                                    <td className="width-30p">
                                        Em Vigor na data de referência{" "}
                                    </td>
                                </tr>
                            )
                            )}
                        </tbody>
                    </Table>
                ) : (
                    <p className="empty-set">Não existem horários disponíveis.</p>
                )}
            </Row>
        );
    }

    onStopRowClick(stop){
        const { selectedStops } = this.state;
        
        var index = selectedStops.findIndex(s => s === stop.id);
        if(index !== -1){
            selectedStops.splice(index, 1);
        }else{
            selectedStops.push(stop.id);
        }

        this.setState({
            selectedStops: selectedStops
        });
    }

    onSelectAllStops(){
        var { data, selectedStops } = this.state

        if(data.stops.length === selectedStops.length){
            selectedStops = [];
        }else{
            data.stops.forEach((stop) => {
                if(selectedStops.findIndex(s => s.code === stop.code) === -1){
                    selectedStops.push(stop.id);
                }
            })
        }

        this.setState({
            selectedStops: selectedStops
        })
    }

    onChangeSort(column) {
        const { sort } = this.state;

        if (sort.column === column) {
            sort.order = sort.order === "ascending" ? "descending" : "ascending";
        } else {
            sort.column = column;
            sort.order = "ascending";
        }

        this.setState({
            sort: sort
        });
    }

    sort(first, second) {
        const { sort } = this.state;

        var a = (first)[sort.column];
        var b = (second)[sort.column];

        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined) {
            if (sort.order === "ascending") {
                return 1;
            } else {
                return -1;
            }
        } else if (b === undefined) {
            if (sort.order === "ascending") {
                return -1;
            } else {
                return 1;
            }
        }

        if (sort.order === "ascending") {
            return typeof a === 'number' ? a - b : a.localeCompare(b);
        }
        return typeof b === 'number' ? b - a : b.localeCompare(a);
    }

    renderOrientationLabel(orientation) {
        switch (orientation) {
            case 'C': return "Circular";
            case 'R': return "Volta";
            case 'G': return "Ida";
            case undefined: return "Não Definido";
            default: return "Ambos";
        }
    }

    renderStopsTab() {
        const { selectedStops, sort, data, actions } = this.state;

        let stops = data['stops'];
        
        return (
            <Tab eventKey={4} key="stops" title="Paragens">
                {actions.isLoadingStops ? <LoadingSpinner /> :
                    data.stops.length !== 0 ? (
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th className="width-20p" onClick={() => this.onChangeSort("code")}> 
                                        Código {sort.column === 'code'? <SortIndicator order={sort.order}/> : <SortIndicator order="none"/>}
                                    </th>
                                    <th className="width-60p" onClick={() => this.onChangeSort("name")}> 
                                        Nome {sort.column === 'code'? <SortIndicator order={sort.order}/> : <SortIndicator order="none"/>}
                                    </th>
                                    <th className="width-20p"> Orientação </th>
                                    <th>
                                        <Button bsSize="small" className="pull-right" onClick={() => this.onSelectAllStops()}>
                                            SELECIONAR TUDO
                                        </Button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {stops.sort((a, b) => this.sort(a, b)).map((stop, idx) =>
                                    <tr key={`stop-${idx}`}
                                        className={`selectable ${selectedStops.findIndex(s => s === stop.id) !== -1 ? "bus-sched-line-selected" : ""}`}
                                        onClick = {(a) => this.onStopRowClick(stop)}
                                    >
                                        <td>{stop.code !== 'undefined' ? stop.code : ''}</td>
                                        <td>{stop.name !== 'undefined' ? stop.name : ''}</td>
                                        <td colSpan={2}>{this.renderOrientationLabel(stop.orientation)}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    ) : (
                        <p className="empty-set padding-left-15">Nenhuma linha selecionada.</p>
                    )}
            </Tab>
        )
    }

    renderSchedulesTab() {
        const { selectedLine, data, actions } = this.state;

        let weekdayScheds = data['schedules'].filter((sched) => this.isWeekdaySchedule(sched));
        let saturdayScheds = data['schedules'].filter((sched) => this.isSaturdaySchedule(sched));
        let sundayScheds = data['schedules'].filter((sched) => this.isSundaySchedule(sched));

        return (
            <Tab eventKey={2} key="sched" title="Horários">
                {actions.isLoadingSchedules ? <LoadingSpinner /> :
                    selectedLine !== undefined ? (
                        <Col sm={12}>
                            {this.renderSchedulesTable("weekdaySchedules", weekdayScheds)}
                            {this.renderSchedulesTable("saturdaySchedules", saturdayScheds)}
                            {this.renderSchedulesTable("sundaySchedules", sundayScheds)}
                        </Col>
                    ) : (
                        <p className="empty-set padding-left-15">Nenhuma linha selecionada.</p>
                    )}
            </Tab>
        );
    };

    renderOptionsTab() {
        return (
            <Tab eventKey={3} key="options" title="Opções">
                <Col sm={10} md={6} className="margin-top-15">
                    <TitleRow
                        title="Cabeçalho"
                        showSeparator={false}
                        showBackground={true}
                        element="h2"
                    />
                    <FormControl
                        type="text"
                        value={this.state.header1}
                        placeholder="Cabeçalho 1"
                        onChange={(e) => this.storeValue("header1", e.target.value)}
                    />
                    <FormControl
                        type="text"
                        value={this.state.header2}
                        placeholder="Cabeçalho 2"
                        onChange={(e) => this.storeValue("header2", e.target.value)}
                    />
                </Col>
                <Col sm={10} md={6} className="margin-top-15">
                    <TitleRow
                        title="Rodapé"
                        showSeparator={false}
                        showBackground={true}
                        element="h2"
                    />
                    <FormControl
                        type="text"
                        value={this.state.footer1}
                        placeholder="Rodapé 1"
                        onChange={(e) => this.storeValue("footer1", e.target.value)}
                    />
                    <FormControl
                        type="text"
                        value={this.state.footer2}
                        placeholder="Rodapé 2"
                        onChange={(e) => this.storeValue("footer2", e.target.value)}
                    />
                </Col>
            </Tab>
        );
    };

    tabularModeScreens() {
        const { selectedLine } = this.state;

        let contents = [this.selectLinesTable()];

        if (selectedLine === undefined) {
            contents.push([<hr />, this.selectSchedulesTable()]);
        }
        return contents;
    };

    generateSuccessCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    generateErrorCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    generateSchedules() {
        var { commands, selectedScheduleType, selectedLine, selectedSchedules, selectedStops, referenceDate, headerAndFooter } = this.state;

        const parameters = {
            type: selectedScheduleType,
            lineId: selectedLine.id,
            stopIds: selectedStops,
            weekdaySchedules: selectedSchedules.weekdaySchedules,
            saturdaySchedules: selectedSchedules.saturdaySchedules,
            sundaySchedules: selectedSchedules.sundaySchedules,
            referenceDate: referenceDate,
            headerAndFooter: headerAndFooter,
        };

        commands.draw.generateViaPortoLineSched(
            parameters,
            (a) => this.generateSuccessCallback(a),
            (a) => this.generateErrorCallback(a)
        );
    }

    generate() {
        const { actions, message, selectedLine, selectedSchedules } = this.state;

        if (selectedLine === undefined) {
            actions.isGenerating = false;
            message.show = true;
            message.message = "Antes de gerar é necessário selecionar pelo menos uma paragem.";
            message.title = "Aviso";
            message.style = "warning";
            message.icon = "alert";
        } 
        else if (selectedSchedules.length === 0) {
            actions.isGenerating = false;
            message.show = true;
            message.message = "Antes de gerar é necessário selecionar pelo menos um horário.";
            message.title = "Aviso";
            message.style = "warning";
            message.icon = "alert";
        } else {
            actions.isGenerating = true;
        }
        this.setState({
            actions: actions,
            message: message
        }, () => { 
            if(actions.isGenerating) {
                this.generateSchedules();
            }
        });
    }

    renderContent() {
        const { selectedScheduleType } = this.state;

        return (
            <Tabs id="bussched_tabs">
                {this.renderLinesTab()}
                {selectedScheduleType === TYPE_STATION && (
                    this.renderStopsTab()
                )}
                {this.renderSchedulesTab()}
                {this.renderOptionsTab()}
            </Tabs>
        )
    }

    render() {
        const { referenceDate, message, actions } = this.state;

        return (
            <div>
                <TitleRow
                    title="ViaPorto Custom Schedule Generator"
                    showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            <Button
                                bsStyle="success"
                                onClick={() => this.generate()}>
                                Gerar
                            </Button>
                            <Button
                                bsStyle={
                                    this.state.selectedScheduleType === TYPE_TABULAR
                                        ? "primary"
                                        : "default"
                                }
                                onClick={() => this.selectScheduleType(TYPE_TABULAR)}>
                                Tabular Web
                            </Button>
                            <Button
                                bsStyle={
                                    this.state.selectedScheduleType === TYPE_FREQUENCY
                                        ? "primary"
                                        : "default"
                                }
                                onClick={() => this.selectScheduleType(TYPE_FREQUENCY)}>
                                Frequências Web
                            </Button>
                            <Button
                                bsStyle={
                                    this.state.selectedScheduleType === TYPE_STATION
                                        ? "primary"
                                        : "default"
                                }
                                onClick={() => this.selectScheduleType(TYPE_STATION)}>
                                Por Estação
                            </Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>
                <Row className="no-margin padding-top-20 padding-bottom-20">
                    <Col sm={3} md={2}>
                        <ControlLabel className="padding-top-10">
                            Data de Referência
                        </ControlLabel>
                    </Col>
                    <Col sm={5} md={7}>
                        <DatePicker
                            id="referenceDateDatePicker"
                            dateFormat="DD/MM/YYYY"
                            value={referenceDate}
                            placeholder="Introduza a Data de Referência"
                            onChange={(e) => this.handleReferenceDateChange(e)} />
                    </Col>
                </Row>
                {actions.isGenerating ? <LoadingSpinner /> : (
                    <Row className="no-margin">
                        {this.renderContent()}
                    </Row>
                )}
                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    argument={message.argument}
                    onHide={() => this.onExit()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/viaPorto/ViaPortoScheduleGenerator.js